/* eslint-disable jsx-a11y/label-has-for */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Flex, Icon, Label } from 'nallian-shared-ui/lib/components';
import HasSomeRights from 'nallian-shared-ui/lib/layout/rights/HasSomeRights';
import { Table } from 'semantic-ui-react';
import { ASSIGNMENT_MODES } from '../../constants';

const USER_GROUP_UNASSIGN_MEMBER_RIGHTS = [
  'user-groups/unassign/own-organisation',
  'user-groups/unassign/system-organisation',
  'user-groups/unassign/non-system-organisation',
];

const UserGroupMember = ({ member, handleRemoveMember }) => {
  const { t } = useTranslation();

  const handleRemove = useCallback(() => handleRemoveMember(member.id), [
    member,
    handleRemoveMember,
  ]);
  return (
    <Table.Row key={member.id}>
      <Table.Cell width="6">
        <Flex fluid alignItems="center">
          {member.principal?.fullName}{' '}
          {member.assignmentMode === ASSIGNMENT_MODES.IDP && (
            <Flex margin="0 0 0 0.5rem">
              <Label color="orange" horizontal>
                {t('viaIdp')}
              </Label>
            </Flex>
          )}
        </Flex>
      </Table.Cell>
      <Table.Cell width="4" textAlign="right">
        <HasSomeRights rights={USER_GROUP_UNASSIGN_MEMBER_RIGHTS}>
          <Icon iconbutton name="trash" onClick={handleRemove} />
        </HasSomeRights>
      </Table.Cell>
    </Table.Row>
  );
};

UserGroupMember.propTypes = {
  member: PropTypes.object.isRequired,
  handleRemoveMember: PropTypes.func.isRequired,
};

export default UserGroupMember;
